import { render, staticRenderFns } from "./NotConnected.vue?vue&type=template&id=673ff101&scoped=true&"
var script = {}
import style0 from "./NotConnected.vue?vue&type=style&index=0&id=673ff101&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ff101",
  null
  
)

export default component.exports